// Hero.js
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import heroImage from '../assets/hero-image.jpg';

const Hero = () => {
  return (
    <section className="relative w-full h-[88vh] min-h-[620px] overflow-hidden">
      {/* Background image */}
      <img
        src={heroImage}
        alt="A nurse holding the hand of an older woman at home"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Legibility overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-black/30" />

      {/* Content */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-end pb-14 md:pb-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div className="max-w-2xl">
            <p className="text-white/90 text-xs md:text-sm font-medium tracking-[0.2em] uppercase mb-5">
              Personal &amp; Aged Care
            </p>
            <h1 className="font-display text-white font-light leading-[1.05] text-4xl md:text-5xl lg:text-6xl mb-5">
              Quality Care That Respects<br className="hidden md:block" /> Every Individual
            </h1>
            <p className="text-white/85 text-base md:text-lg font-light leading-relaxed max-w-xl">
              Helping individuals and families across Canberra access dependable, person-centred care
              with clear standards and responsive support.
            </p>
          </div>

          <Link
            to="/services/personal-care"
            className="shrink-0 inline-flex items-center gap-3 bg-white text-bnInk hover:bg-bnCream font-medium text-sm md:text-base pl-7 pr-5 py-4 rounded-full transition-colors shadow-sm"
          >
            Explore Care Services
            <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-bnAccent text-white">
              <ArrowRight size={16} />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
